import { useCallback } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface Props {
  placeName: string
  removedDayCount: number
}

function ConfirmShortenStopModal({ placeName, removedDayCount }: Props) {
  const intl = useIntl()
  const modalElement = useModalElementContext<boolean>()

  const handleClose = useCallback(() => {
    modalElement.resolve(false)
  }, [modalElement])

  const handleConfirm = useCallback(() => {
    modalElement.resolve(true)
  }, [modalElement])

  return (
    <Modal
      title={intl.formatMessage({
        id: 'MFvn19_6oimDT5_nLtPQ',
        defaultMessage: 'Shorten this stop?',
        description: 'Title for confirming a shorter duration that removes planned stop days',
      })}
      primaryActionText={intl.formatMessage({
        id: 'lAkw8KI-L4E0iB-yMTUk',
        defaultMessage: 'Shorten stop',
        description: 'Primary action label confirming removal of planned days from a trip stop',
      })}
      secondaryActionText={intl.formatMessage({
        id: 'eDS-KRpN6U2pMC6LXR4A',
        defaultMessage: 'Cancel',
        description: 'Secondary action label cancelling a shorter trip stop duration',
      })}
      onPrimaryActionClick={handleConfirm}
      onSecondaryActionClick={handleClose}
      onClose={handleClose}
      tabletHeight="auto"
    >
      <BodyText variant="medium">
        <FormattedMessage
          id="gzz-gQEFEznSATzm_FV-"
          defaultMessage="{removedDayCount, plural, one {# planned day} other {# planned days}} will be removed from <bold>{placeName}</bold>. Items on those days may move to To be planned."
          description="Warning shown before shortening a stop removes existing planned itinerary days"
          values={{
            placeName,
            removedDayCount,
            bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
          }}
        />
      </BodyText>
    </Modal>
  )
}

export default ConfirmShortenStopModal
